module.exports = __webpack_public_path__ + "static/media/img001.80e98099.jpg";